<template>
  <div class="right-asilde">
    <el-tabs type="border-card" v-model="activeName">
      <el-tab-pane label="我的图库" name="myimage">
        <my-gallery @add_ueditor_value="add_ueditor_value_fn" v-if="activeName=== 'myimage'" :active-menu="activeName"></my-gallery>
      </el-tab-pane>
      <el-tab-pane label="免版权图" name="image">
        <my-gallery @add_ueditor_value="editorInfo" v-if="activeName=== 'image'" :active-menu="activeName"></my-gallery>
      </el-tab-pane>
      <el-tab-pane label="GIF表情" name="face">
        <my-gallery @add_ueditor_value="editorInfo" v-if="activeName=== 'face'" :active-menu="activeName"></my-gallery>
      </el-tab-pane>
      <el-tab-pane label="常用图标" name="icon">
        <my-gallery @add_ueditor_value="editorInfo" v-if="activeName=== 'icon'" :active-menu="activeName"></my-gallery>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MyGallery from './my-gallery'

export default {
  data() {
    return {
      activeName: 'myimage',
      info: null
    }
  },
  methods: {
    add_ueditor_value_fn(obj) {
      obj.types = 'pic'
      this.info = obj
      this.$emit("add_ueditor_value", obj);
    }
  },

  components: {
    MyGallery
  }
}
</script>

<style lang="scss" scoped>
.right-asilde{
  width: 390px;
  margin-left: 80px;
  .el-tabs__content{
    min-height: 100%;
    overflow-y: auto;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/rightAsilde/right-asilde.vue